module.exports = __webpack_public_path__ + "static/media/not_found.35fcbed4.svg";